import $ from 'jquery'
import i18n from "../../i18n";
import home from '../../api/home'

const state = {
    currentLocale: 'en' // use getCurrentLocale to get the correct locale
}

const getters = {

}

const actions = {
    changeLocale ({ commit }, localeCode) {
        home.getLocal(localeCode).then(response => {
            commit('setCurrentLocaleCode', localeCode)

            // Reset events for load description in new selected lang
            commit('event/setEvents', [], {root: true})

            location.reload();
        })
    },

    getCurrentLocale ({ commit }) {
        // restore the current locale code from the html meta tag
        const locale = $('html')[0].lang
        commit('setCurrentLocaleCode', locale ?? 'en')
        return state.currentLocale
    }
}

const mutations = {
    setCurrentLocaleCode (state, code) {
        state.currentLocale = code
        i18n.locale = code
        document.documentElement.lang = code
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
